var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiloLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.78 242.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#191c52;}.cls-2{fill:#9ecb3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.78,121.39A121.39,121.39,0,1,1,121.39,0,121.39,121.39,0,0,1,242.78,121.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.77,78.44h15.42V90.15H109.77Zm0,17.19h15.42V147.2H109.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.6,
    y: 78.44,
    width: 15.42,
    height: 68.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.52,148.78c-15.7,0-27.78-11.61-27.78-27.41,0-16,12.36-27.41,27.78-27.41s27.78,11.61,27.78,27.22c0,16.17-12.27,27.59-27.78,27.59m12.36-27.41c0-6.87-5.2-13-12.45-13-6.78,0-12.27,5.95-12.27,13s5.39,13,12.36,13c7.25,0,12.36-6.13,12.36-13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105,144.67h0c-.29,0-.56-.17-.56-.49V81.06a3,3,0,1,0-5.92,0v65.12h0a.61.61,0,0,1-1.23,0V81.06a3,3,0,1,0-5.92,0v65.12a.61.61,0,0,1-1.23,0h0V81.05h0a3,3,0,1,0-5.92,0h0l0,65.07v.07a.61.61,0,0,1-1.23,0V107.11h0a3,3,0,0,0-5.92,0h0v14.6a.6.6,0,0,1-1.21,0V107.18s0,0,0,0,0,0,0,0h0a3,3,0,0,0-5.92,0h0v14.6a.6.6,0,0,1-1.21,0v-14.6h0a3,3,0,0,0-5.92,0h0v0h0v0l0,38.88v.14a.61.61,0,0,1-1.23,0V81.05h0a3,3,0,1,0-5.91,0h0l0,64.77v.36a.61.61,0,0,1-1.23,0V81.05h0a3,3,0,1,0-5.91,0h0v65.13a.61.61,0,0,1-1.23,0V81.1h0a3,3,0,1,0-5.92,0h0l0,62a2.18,2.18,0,0,1-2.19,2.1,2.09,2.09,0,0,1-2.09-1.91V143a3.86,3.86,0,1,0-7.72,0v1.58c0,.67-1.22.67-1.22,0H25.76a3,3,0,0,0,6,0V143a1.46,1.46,0,0,1,1.45-1.46,1.48,1.48,0,0,1,1.46,1.55c0,.14,0,.28,0,.41a4.51,4.51,0,0,0,9-.41v-62a.6.6,0,0,1,1.2,0v65.1a3,3,0,0,0,5.92,0h0V81a.6.6,0,0,1,1.2,0v65.15h0a3,3,0,0,0,5.92,0h0V81a.6.6,0,0,1,1.2,0v65.15h0a3,3,0,0,0,5.92,0V107.12a.6.6,0,0,1,1.21,0v14.52s0,0,0,0,0,0,0,0h0a3,3,0,0,0,5.92,0h0v-14.6a.6.6,0,0,1,1.21,0v14.6h0a3,3,0,0,0,5.92,0h0v0h0V107.12a.6.6,0,0,1,1.2,0v39.07a3,3,0,0,0,5.92,0h0V81a.6.6,0,0,1,1.2,0v65.15a3,3,0,1,0,5.92,0l0-65.12v0a.6.6,0,0,1,1.2,0v65.15a3,3,0,1,0,5.92,0l0-65.12v0a.6.6,0,0,1,1.2,0v63.15a3,3,0,0,0,2.91,3h2.16v-2.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.37 160.23 43.05 160.23 43.05 168.36 47.91 168.36 47.91 169.8 41.37 169.8 41.37 160.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.27,165c0,2.74-1.72,5-4.58,5s-4.59-2.28-4.59-5,1.72-5,4.59-5,4.58,2.28,4.58,5m-7.49,0c0,1.84.86,3.65,2.91,3.65s2.91-1.81,2.91-3.65-.86-3.65-2.91-3.65-2.91,1.81-2.91,3.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.83 166.05 61.24 160.23 63.19 160.23 65.72 164.52 68.21 160.23 70.09 160.23 66.51 166.05 66.51 169.8 64.83 169.8 64.83 166.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.14,160.23h1.78l3.69,9.57h-1.8l-.9-2.53H73.09l-.9,2.53H70.47ZM73.55,166h2.92L75,161.88h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.07 160.23 83.74 160.23 83.74 168.36 88.61 168.36 88.61 169.8 82.07 169.8 82.07 160.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.16 160.23 96.91 160.23 96.91 161.68 93.87 161.68 93.87 169.8 92.19 169.8 92.19 161.68 89.16 161.68 89.16 160.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.06 166.05 98.47 160.23 100.41 160.23 102.94 164.52 105.44 160.23 107.31 160.23 103.73 166.05 103.73 169.8 102.06 169.8 102.06 166.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.04 160.23 117.4 160.23 120.04 167.73 120.07 167.73 122.64 160.23 124.97 160.23 124.97 169.8 123.38 169.8 123.38 162.42 123.35 162.42 120.7 169.8 119.32 169.8 116.66 162.42 116.63 162.42 116.63 169.8 115.04 169.8 115.04 160.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.09,160.23h1.78l3.69,9.57h-1.8l-.9-2.53H130l-.9,2.53h-1.73ZM130.5,166h2.92L132,161.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139,160.23h4.57c2.09,0,3.16,1,3.16,2.59a2.32,2.32,0,0,1-1.58,2.41v0c.58.08,1.42.51,1.42,2a4.34,4.34,0,0,0,.52,2.52h-1.8a2.67,2.67,0,0,1-.25-1.41c0-1.76-.36-2.53-1.9-2.53h-2.47v3.94H139Zm1.68,4.36h2.75c1.06,0,1.64-.52,1.64-1.53,0-1.22-.79-1.46-1.66-1.46h-2.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150 160.23 151.67 160.23 151.67 164.59 155.94 160.23 158 160.23 154.18 164.05 158.27 169.8 156.18 169.8 153.04 165.23 151.67 166.59 151.67 169.8 150 169.8 150 160.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "160.72 160.23 167.62 160.23 167.62 161.68 162.4 161.68 162.4 164.19 167.23 164.19 167.23 165.55 162.4 165.55 162.4 168.36 167.71 168.36 167.71 169.8 160.72 169.8 160.72 160.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.8 160.23 177.55 160.23 177.55 161.68 174.51 161.68 174.51 169.8 172.83 169.8 172.83 161.68 169.8 161.68 169.8 160.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 180.21,
    y: 160.23,
    width: 1.68,
    height: 9.57
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "185.41 160.23 187.18 160.23 191.55 167.28 191.58 167.28 191.58 160.23 193.17 160.23 193.17 169.8 191.4 169.8 187.05 162.76 187.01 162.76 187.01 169.8 185.41 169.8 185.41 160.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.05,169.8H204l-.25-1.13a3.45,3.45,0,0,1-2.88,1.35c-2.87,0-4.59-2.28-4.59-5s1.72-5,4.59-5c2.09,0,3.85,1.11,4.1,3.27h-1.64a2.28,2.28,0,0,0-2.47-1.9c-2,0-2.91,1.81-2.91,3.65s.86,3.65,2.91,3.65a2.43,2.43,0,0,0,2.68-2.63H201v-1.27h4.08Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloLogo);
export default __webpack_public_path__ + "static/media/hilo-logo.d05e4ca683bb70c15246f5845fa8f563.svg";
export { ForwardRef as ReactComponent };